import { useEffect } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const DownloadPedagogicalPlanXLSX = ({ dataXLSX, onFinish }) => {
  useEffect(() => {
    const generateExcel = async () => {
      const fieldLabels = {
        codigoProyecto: 'Código Proyecto',
        subregion: 'Subregión',
        municipio: 'Municipio',
        nombreProyecto: 'Nombre del Proyecto',
        lineaProductiva: 'Línea Productiva',
        subsector: 'Subsector',
        FactibilidadProductoresFamilias: 'Productores / Familias',
        factibilidadVisitas: 'Visitas',
        factibilidadConformacionECA: 'Conformación ECA',
        factibilidadSesionesECA: 'Sesiones ECA',
        factibilidadNumeroOrg: 'Número de Organizaciones',
        encuentrosAcompanamientoOrg: 'Encuentros Acompañamiento',
        tematicasAcompanamientoOrg: 'Temáticas Acompañamiento',
        encuestaDHAA: 'Encuesta DHAA',
        aplicacionInstrumento: 'Aplicación Instrumento',
        prediosIPPTA: 'Predios IPPTA',
        EnfoqueGenero: 'Enfoque de Género',
        enfoqueEtnico: 'Enfoque Étnico',
        enfoqueReparador: 'Enfoque Reparador',
        enfoqueCiclodeVida: 'Enfoque Ciclo de Vida',
        Observaciones: 'Observaciones',
        ...Object.fromEntries(Array.from({ length: 10 }, (_, i) => [`Sesion${i + 1}`, `Sesión ${i + 1}`]))
      };

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Plan Pedagógico ' + dataXLSX.codigoProyecto);

      const validEntries = Object.entries(dataXLSX)
        .filter(([key, value]) => value !== "" && value !== null && fieldLabels[key]);

      const headers = validEntries.map(([key]) => fieldLabels[key]);
      const values = validEntries.map(([, value]) => value);


      const title =
      "PLANES PEDAGÓGICOS DE EXTENSIÓN Y ACOMPAÑAMIENTO TÉCNICO A TRAVÉS DE ESCUELAS DE CAMPO DE AGRICULTORES Y AGRICULTORAS – ECA Y VISITAS DE ACOMPAÑAMIENTO CON ENFOQUES DIFERENCIALES" +
      ` - ${dataXLSX.codigoProyecto} ${dataXLSX.subregion}`;     
      worksheet.mergeCells(1, 1, 1, headers.length); 
      const headerCell = worksheet.getCell('A1');
      headerCell.value = title;
      headerCell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
      headerCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4F81BD' } };
      headerCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      worksheet.getRow(1).height = 50; // Altura del título


      worksheet.addRow(headers);
      worksheet.addRow(values);

      headers.forEach((_, i) => {
        const cell = worksheet.getRow(2).getCell(i + 1);
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      });


      values.forEach((_, i) => {
        const cell = worksheet.getRow(3).getCell(i + 1);
        cell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
      });

      worksheet.columns.forEach((column) => {
        column.width = 40; // ~300px
      });

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `Plan_Pedagogico_${dataXLSX.codigoProyecto}.xlsx`);

      if (onFinish) onFinish();
    };

    generateExcel();
  }, [dataXLSX, onFinish]);

  return null;
};

export default DownloadPedagogicalPlanXLSX;
